import { useSyncExternalStore } from 'react';
import { reachabilityStore, type ServerReachability } from '@doccareplus/api-client';

/**
 * Subscribe to the shared server-reachability status (driven by real API traffic
 * in the api-client). Bridges the framework-agnostic store into React — api-client
 * itself stays React-free.
 */
export function useServerReachability(): ServerReachability {
  return useSyncExternalStore(
    reachabilityStore.subscribe,
    reachabilityStore.get,
    reachabilityStore.get
  );
}
